import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AppUrl from "../../RestApi/AppUrl";
import RestClient from "../../RestApi/RestClient";
import Loader from "../../shared/Loader/Loader";
import WentWrong from "../../shared/WentWrong/WentWrong";
import AboutDescriptionCss from "./AboutDescription.module.css";
export default function AboutDescription() {
  const [aboutUs, setAboutUs] = useState({
    whoAmI: "",
    mission: "",
    vision: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    RestClient.GetRequest(AppUrl.allAbout).then((result) => {
      if (result == null) {
        setError(true);
      } else {
        console.log(result);
        setAboutUs({
          whoAmI: result[0]["descriptoon"],
          mission: result[0]["mission"],
          vision: result[0]["vision"],
        });
        setLoading(false);
      }
    });
  }, []);
  return (
    <>
      {loading && <Loader />}
      <Container className="mt-4">
        {!error ? (
          <Row>
            <Col md={12} lg={12} sm={12}>
              <h1 className={`${AboutDescriptionCss.title}`}>Who I Am ?</h1>
              <hr />
              <p className={`${AboutDescriptionCss.serviceDescription}`}>
                {aboutUs.whoAmI}
              </p>
              <h1 className={`${AboutDescriptionCss.title}`}>Our Mission </h1>
              <hr />
              <p className={`${AboutDescriptionCss.serviceDescription}`}>
                {aboutUs.mission}
              </p>

              <br></br>
              <br></br>
              <h1 className="serviceName">Our Vision </h1>
              <hr />
              <p className={`${AboutDescriptionCss.serviceDescription}`}>
                {aboutUs.vision}
              </p>
            </Col>
          </Row>
        ) : (
          <WentWrong />
        )}
      </Container>
    </>
  );
}
